import React from "react";
import PropTypes from "prop-types";

import styles from "./Tooltip.css";
import classNames from "classnames";

export default function Tooltip(props) {
  if (!props.isOpen || !props.text) {
    return null;
  }

  return (
    <div
      className={classNames(styles.root, {
        [styles.left]: props.isLeftAligned,
      })}
    >
      {props.text}
    </div>
  );
}

Tooltip.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  isLeftAligned: PropTypes.bool,
};
